import React from 'react';

const Projects = () => {
  const projects = [
    { title: 'Africa Trade Corridor', description: 'Infrastructure development project connecting key trade routes.' },
    { title: 'Agri-Business Initiative', description: 'Supporting agricultural value chains across West Africa.' },
    { title: 'Digital Skills Program', description: 'Training young Africans in digital and tech skills.' },
  ];

  return (
    <div>
      <section className="page-hero">
        <h1>Our Projects</h1>
        <p>Initiatives driving African development</p>
      </section>
      <section className="page-content">
        <div className="container">
          {projects.map((project, index) => (
            <div className="project-item" key={index}>
              <h3>{project.title}</h3>
              <p>{project.description}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Projects;